'use strict';

angular.module('magtac')
  .controller('CustomerStatusCtrl', [
    '$scope', 'customerStatusViewModel', 'timersConfigViewModel', '$stateParams',
    function ($scope, viewModel, timerViewModel, $stateParams) {
      var customerId = parseInt($stateParams.key);
      $scope.timerModel = new timerViewModel(customerId);

      $scope.model = new viewModel(customerId, $scope.timerModel);

    }
  ]);
